<div class="bw">
  <header id="tour-fax-header" class="bw__header">
    <div class="bw__title-row">
      <h1>Fax Audit</h1>
      <button
        pButton
        [text]="true"
        [rounded]="true"
        icon="pi pi-question-circle"
        pTooltip="Start tour"
        tooltipPosition="bottom"
        (click)="startTour()"
      ></button>
    </div>
  </header>

  <section class="bw__content">
    <app-domain-multiple-selector
      id="tour-fax-domain-selector"
      [domains]="domains"
      [label]="messages.SELECT_DOMAINS"
      [buttonLabel]="messages.GET_INFORMATION"
      [panelCollapsed]="collapsed"
      [requesting]="requesting"
      (selectionChanged)="onDomainSelectionChanged($event)"
    >
    </app-domain-multiple-selector>

    @if (tableData.length > 0) {
      <div id="tour-fax-results" class="mt-2">
        @for (tableItem of tableData; track tableItem.domainId) {
          <div class="mb-2">
            <div class="grid grid-cols-2 w-full mb-3">
              <div class="w-6">
                <div class="text-xl mb-3">
                  <span class="font-bold">Domain: </span>
                  <span>{{ getDomainSummary(tableItem).domainId }}</span>
                </div>
                <div class="mb-3">
                  <span class="font-bold">Total accounts: </span>
                  <span>{{ getDomainSummary(tableItem).accountCount }}</span>
                </div>
              </div>
              <div class="w-6 text-right">
                <p-button
                  icon="pi pi-upload"
                  [disabled]="!hasSelectedAccounts(tableItem)"
                  [rounded]="true"
                  [raised]="true"
                  severity="info"
                  size="large"
                  [pTooltip]="messages.UPDATE_ACCOUNTS"
                  tooltipPosition="left"
                  (onClick)="onUpdateAccounts(tableItem.selectedItems!)"
                >
                </p-button>
              </div>
            </div>

            <div class="mb-3">
              <div class="flex gap-2 align-items-center flex-wrap">
                <input
                  type="text"
                  pInputText
                  [(ngModel)]="tableItem.searchTerm"
                  placeholder="Search..."
                  (keyup.enter)="onSearch(tableItem)"
                  class="flex-1"
                />
                <p-multiSelect
                  [(ngModel)]="tableItem.selectedFilterFields"
                  [options]="availableFilterFields"
                  placeholder="Filter by fields"
                  [style]="{ width: '200px' }"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  (onChange)="onFilterChange(tableItem)"
                ></p-multiSelect>
                <p-button
                  label="Search"
                  icon="pi pi-search"
                  (onClick)="onSearch(tableItem)"
                ></p-button>
                <p-button
                  label="Clear"
                  icon="pi pi-times"
                  severity="secondary"
                  (onClick)="onClearSearch(tableItem)"
                ></p-button>
                <p-button
                  type="button"
                  icon="pi pi-cog"
                  label="Columns"
                  severity="success"
                  (onClick)="colConfigOverlay.toggle($event)"
                  pTooltip="Toggle columns"
                ></p-button>
                <p-overlayPanel #colConfigOverlay>
                  <div class="flex flex-column gap-2" style="min-width: 200px">
                    <div class="font-semibold mb-2">Toggle Columns</div>
                    @for (column of columns; track column.key) {
                      <div class="flex align-items-center gap-2">
                        <p-checkbox
                          [binary]="true"
                          [(ngModel)]="tableItem.columnVisibility[column.key]"
                          [inputId]="'col-' + tableItem.domainId + '-' + column.key"
                        ></p-checkbox>
                        <label
                          [for]="'col-' + tableItem.domainId + '-' + column.key"
                          class="cursor-pointer"
                        >
                          {{ column.label }}
                        </label>
                      </div>
                    }
                  </div>
                </p-overlayPanel>
              </div>
            </div>

            <p-table
              [value]="tableItem.filteredItems"
              [selectionMode]="'multiple'"
              [(selection)]="tableItem.selectedItems"
              [paginator]="true"
              [rows]="defaultPageSize"
              [rowsPerPageOptions]="pageSizeOptions"
              styleClass="p-datatable-striped"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th class="w-1"><p-tableHeaderCheckbox /></th>
                  @if (isColumnVisible(tableItem, 'accountIdNumeric')) {
                    <th class="w-2" pSortableColumn="accountIdNumeric">
                      Account id
                      <p-sortIcon field="accountIdNumeric" />
                    </th>
                  }
                  @if (isColumnVisible(tableItem, 'clientTypeDecoded')) {
                    <th class="w-4" pSortableColumn="clientTypeDecoded">
                      Client type
                      <p-sortIcon field="clientTypeDecoded" />
                    </th>
                  }
                  @if (isColumnVisible(tableItem, 'faxType')) {
                    <th class="w-4" pSortableColumn="faxType">
                      Fax type
                      <p-sortIcon field="faxType" />
                    </th>
                  }
                  <th class="w-1">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-account>
                <tr>
                  <td><p-tableCheckbox [value]="account" /></td>
                  @if (isColumnVisible(tableItem, 'accountIdNumeric')) {
                    <td>{{ account.accountIdNumeric }}</td>
                  }
                  @if (isColumnVisible(tableItem, 'clientTypeDecoded')) {
                    <td>{{ account.clientTypeDecoded }}</td>
                  }
                  @if (isColumnVisible(tableItem, 'faxType')) {
                    <td>{{ account.faxType }}</td>
                  }
                  <td class="text-right">
                    <p-button
                      icon="pi pi-upload"
                      [rounded]="true"
                      [raised]="true"
                      severity="info"
                      size="small"
                      (onClick)="onUpdateAccounts([account])"
                    />
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="getVisibleColumnsCount(tableItem) + 2">
                    {{ messages.NO_ACCOUNTS }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    }
  </section>
</div>
